<template>
  <!-- Combobox chọn năm học -->
  <ms-combo-box
    v-if="isActiveComponent"
    style="width: 185px"
    class="mr-3"
    :items="listSchoolYear"
    :readonly="true"
    value-field="SchoolYear"
    display-field="SchoolYearDisplay"
    v-model="schoolYearActive"
    ref="cboSubject"
    @change="handleChangeSchoolYear"
  />
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
// import idbKeys from '@/common/idb-key'
// import idb from '@/utils/idb'
// import CacheTime from '@/utils/cache-data/src/cache-time'
import { localStorageKeys } from '@/common/storage-keys'
import { localStorage } from '@/utils/storage'
import { getContextData, ContextDataKey } from '@/utils/context-data'
export default {
  data () {
    return {
      schoolYearActive: null,
      isActiveComponent: false
    }
  },
  computed: {
    ...mapState('classroom', ['schoolYears', 'currentSchoolYear']),

    listSchoolYear () {
      const me = this

      const schoolYears = me.schoolYears?.map(schoolYear => {
        return { ...schoolYear, SchoolYearDisplay: me.$t('ClassRoom.SchoolYear', { schoolYearOpen: schoolYear.SchoolYear, schoolYearClose: schoolYear.SchoolYear + 1 }) }
      })

      return schoolYears
    }

  },

  watch: {

    /**
     * Theo dõi giá trị cbbox schoolYear thay đổi thì update vào localStorage
     */
    currentSchoolYear () {
      const me = this
      localStorage.set(localStorageKeys.SCHOOL_YEAR, me.currentSchoolYear)
    }
  },
  async mounted () {
    const me = this

    // Lấy danh sách năm học trong IndexedDB
    const schoolYearData = me.getSchoolYearsDataIndexBD()
    // Lấy năm học hiện tại trong IndexedDB
    const schoolYear = me.getSchoolYearIndexDB()
    if (!schoolYearData || schoolYearData?.length === 0 || !me.checkOrganizationIDIndexedDB(schoolYearData)) {
      await me.getSchoolYears().then(schoolYears => {
        me.setSchoolYears(schoolYears)

        const defaultSchoolYear = me.getDefaultSchoolYear(schoolYears, schoolYear)
        me.setCurrentSchoolYear(defaultSchoolYear)
      })

      me.saveSchoolYear()
    } else {
      me.setSchoolYears(schoolYearData)

      const defaultSchoolYear = me.getDefaultSchoolYear(me.listSchoolYear, schoolYear)
      me.setCurrentSchoolYear(defaultSchoolYear)
    }
    me.isActiveComponent = true
    me.schoolYearActive = me.currentSchoolYear
  },

  methods: {
    ...mapMutations('classroom', ['setSchoolYears', 'setCurrentSchoolYear']),
    ...mapActions('school-year', ['getSchoolYears']),

    /**
     * Lưu danh sách năm học vào IndexDB
     */
    async saveSchoolYear () {
      const me = this
      // const key = idbKeys.SchoolYearData
      // await idb.set(key, me.listSchoolYear)
      localStorage.set(localStorageKeys.SCHOOL_YEAR_DATA, me.listSchoolYear)

      // Lưu năm học hiện tại vào IndexedDB
      // const keySchoolYear = idbKeys.SchoolYear
      // await idb.set(keySchoolYear, me.currentSchoolYear)
      localStorage.set(localStorageKeys.SCHOOL_YEAR, me.currentSchoolYear)
      // await CacheTime.SetCacheTime(key)
    },

    /**
     * Lấy danh sách năm học từ IndexDB
     */

    getSchoolYearsDataIndexBD () {
      // const key = idbKeys.SchoolYearData
      // return await idb.get(key, [])
      return localStorage.get(localStorageKeys.SCHOOL_YEAR_DATA)
    },

    /**
     * Lấy năm học hiện tại trong IndexedDB
     */
    getSchoolYearIndexDB () {
      // const key = idbKeys.SchoolYear
      // return await idb.get(key, [])
      return localStorage.get(localStorageKeys.SCHOOL_YEAR)
    },

    /**
     * Kiểm tra OrganizationID được lưu trong IndexedDB có là OrganizationID của giáo viên hay không
     */
    checkOrganizationIDIndexedDB (schoolYearData) {
      if (schoolYearData.length > 0) {
        const organizationID = schoolYearData[0]?.OrganizationID
        return getContextData(ContextDataKey.OrganizationID) === organizationID
      }
      return true
    },

    /**
     * Lấy giá trị năm học hiện tại
     * Nếu không có trong danh sách năm học hiện tại thì lấy năm học gần nhất
     */
    getDefaultSchoolYear (schoolYearData, currentSchoolYear) {
      const me = this
      let lastestSchollYearData
      const localSchoolYear = localStorage.get(localStorageKeys.SCHOOL_YEAR)
      if (localSchoolYear && me.checkOrganizationIDIndexedDB(schoolYearData)) {
        const index = schoolYearData.findIndex(x => x.SchoolYear === localSchoolYear)
        if (index !== -1) {
          return localSchoolYear
        } else {
          lastestSchollYearData = schoolYearData[schoolYearData?.length - 1]
          if (lastestSchollYearData.SchoolYear === currentSchoolYear) {
            return currentSchoolYear
          }
        }
      }
      if (schoolYearData?.length > 0) {
        lastestSchollYearData = schoolYearData[schoolYearData?.length - 1]
        if (lastestSchollYearData.SchoolYear === currentSchoolYear) {
          return currentSchoolYear
        }
      }

      const defaultSchoolYear = me.getCurrentSchoolYear(lastestSchollYearData, schoolYearData)

      return defaultSchoolYear
    },

    getCurrentSchoolYear (lastestSchoolYear, schoolYears) {
      let schoolYear = 0
      const currentDate = new Date()

      const startTime = new Date(lastestSchoolYear.SemesterIStartDate)
      const startMonth = startTime.getMonth() + 1
      const startDay = startTime.getDate()
      const startDate = new Date(`${currentDate.getFullYear()}/${startMonth}/${startDay}`)

      const endTime = new Date(lastestSchoolYear.EndDate)
      const endMonth = endTime.getMonth() + 1
      const endDay = endTime.getDate()
      const endDate = new Date(`${currentDate.getFullYear() + 1}/${endMonth}/${endDay}`)

      if (startDate <= currentDate && currentDate <= endDate) {
        schoolYear = currentDate.getFullYear()
      } else {
        schoolYear = currentDate.getFullYear() - 1
      }

      const isExist = schoolYears.some(element => element.SchoolYear === schoolYear)
      if (!isExist) {
        schoolYear = lastestSchoolYear.SchoolYear
      }

      return schoolYear
    },

    /**
     * Xử lý thay đổi combo năm học
     */
    handleChangeSchoolYear () {
      const me = this
      me.setCurrentSchoolYear(me.schoolYearActive)
    }

  }
}
</script>

<style lang="scss" scoped>

</style>
